import { render, staticRenderFns } from "./ConsultarAutorizacoesForm.vue?vue&type=template&id=cd3805be&scoped=true"
import script from "./ConsultarAutorizacoesForm.vue?vue&type=script&lang=js"
export * from "./ConsultarAutorizacoesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3805be",
  null
  
)

export default component.exports